export default __webpack_public_path__ + "static/media/redux.86c6a8a3.svg";